import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { Card } from "@/components/ui/card";
import {
  Table,
  TableHeader,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { CreditCard } from "lucide-react";
import { api } from "@/lib/api";
import { TID } from "@/constants/testIds";
import { formatBRL, formatDateTime, STATUS_LABEL } from "@/lib/format";

export default function AdminPayments() {
  const [items, setItems] = useState([]);
  const [companies, setCompanies] = useState({});

  useEffect(() => {
    Promise.all([api.get("/admin/payments"), api.get("/admin/companies")])
      .then(([p, c]) => {
        setItems(p.data);
        setCompanies(Object.fromEntries(c.data.map((x) => [x.id, x])));
      })
      .catch(() => {});
  }, []);

  const tone = (s) => {
    if (s === "paid") return "bg-emerald-100 text-emerald-800 border-emerald-200";
    if (s === "failed") return "bg-rose-100 text-rose-800 border-rose-200";
    if (s === "pending") return "bg-amber-100 text-amber-800 border-amber-200";
    return "bg-stone-100 text-stone-700";
  };

  return (
    <Layout title="Pagamentos" subtitle="Histórico de transações via Stripe">
      <Card data-testid={TID.adminPayments} className="rounded-xl border-stone-200 bg-white overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-stone-50">
              <TableHead className="font-body">Data</TableHead>
              <TableHead className="font-body">Empresa</TableHead>
              <TableHead className="font-body">Método</TableHead>
              <TableHead className="font-body">Valor</TableHead>
              <TableHead className="font-body">Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} className="text-center text-stone-500 py-10">
                  <CreditCard className="h-6 w-6 mx-auto mb-2 text-stone-400" />
                  Sem pagamentos
                </TableCell>
              </TableRow>
            )}
            {items.map((p) => (
              <TableRow key={p.id}>
                <TableCell className="font-body text-sm">{formatDateTime(p.paid_at || p.created_at)}</TableCell>
                <TableCell className="font-display font-semibold">
                  {companies[p.company_id]?.trade_name || p.company_id || "—"}
                </TableCell>
                <TableCell className="font-body text-sm uppercase">{p.method}</TableCell>
                <TableCell className="font-display font-bold">{formatBRL(p.amount)}</TableCell>
                <TableCell>
                  <Badge variant="outline" className={tone(p.status)}>
                    {STATUS_LABEL[p.status] || p.status}
                  </Badge>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </Layout>
  );
}
